import React from "react";
                  
export default function Notification() {
    return <h1>Work in progress!</h1>
}   